import clsx from "clsx";
import { HiOutlineCheck } from "react-icons/hi2";

type Props = {
  innerContent: React.ReactNode;
  checked: boolean;
  active?: boolean;
};

const StepperItem = ({ innerContent, checked, active }: Props) => {
  return (
    <li
      className={clsx(
        "flex items-center text-brand-primary",
        "[&:not(:last-child)]:after:inline-block",
        "[&:not(:last-child)]:after:h-0.5",
        "[&:not(:last-child)]:after:w-full",
        "[&:not(:last-child)]:w-full",
        "[&:not(:last-child)]:after:content-['']",
        checked
          ? "[&:not(:last-child)]:after:bg-success-solid"
          : active
            ? "[&:not(:last-child)]:after:bg-brand-primary-solid-hover"
            : "[&:not(:last-child)]:after:bg-quaternary",
      )}
    >
      <span
        className={clsx(
          "flex size-8 shrink-0 items-center justify-center rounded-full text-sm font-medium",
          checked
            ? "bg-success-solid text-white"
            : active
              ? "bg-brand-primary-solid-hover text-white"
              : "border border-secondary bg-secondary text-quinary",
        )}
      >
        {checked ? <HiOutlineCheck className={"size-5 text-white"} /> : innerContent}
      </span>
    </li>
  );
};

export default StepperItem;
